// extracted by mini-css-extract-plugin
module.exports = {"tabs":"CreatedDocuments_tabs_3Ca22","spinAround":"CreatedDocuments_spinAround_15_Ni"};